import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { XIcon } from "@heroicons/react/solid";
import Modal from "@mui/material/Modal";
import EmployeeTab from "./EmployeeTab";
import useGet from "../../hooks/read/useGet";
import Pagination from "../../components/pagination";
import usePut from "../../hooks/usePut";
import toast from "react-hot-toast";
import InlineLoader from "../../components/loader/InlineLoader";
import SingleResignEmployeeDetail from "./SingleResignEmployeeDetail";
import PrimaryLoader from "../../components/common/PrimaryLoader";
import BreadCrumbs from "../../components/ui/BreadCrumbs";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";
import RoundedContainer from "../../components/containers/RoundedContainer";
import { Button } from "../../components/ui";

const ResignedEmployeeDetails = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const breadcrumbs = [
    { label: "Employees", link: "/employee-details" },
    { label: "Past Employees", link: "/resigned-employee-details" },
  ];
  const initialEmployeeState = {
    limit: 50,
    search_query: searchParams.get("search_query") || "",
    page_number: searchParams.get("page_number") || 0,
    screen_name: "resignation",
  };
  const [isOpenDocumentModal, setIsOpenDocumentModal] = useState(false);
  const {
    list: resignedUserList,
    paramsObject,
    setGetListParams,
  } = useGet({
    url: "employeelist",
    initialData: initialEmployeeState,
  });
  const { handleAuth: revokeEmployee } = usePut({
    url: "revokeUserResignation",
    refreshUrl: "employeelist",
    onSuccess: () => {
      toast.success("Employee Revoked Successfully");
      setIsOpenDocumentModal(false);
    },
    onError: () => {
      toast.error("There Was an error while submitting your request");
    },
  });
  const [userId, setUserId] = useState("");

  const handleFetchUserDocuments = (company_employee_id) => {
    setUserId(company_employee_id);
    setIsOpenDocumentModal(true);
  };

  const handleSearch = (e) => {
    let value = e.target.value;
    let data = {
      ...paramsObject,
      search_query: value,
    };
    setGetListParams(data);
    setSearchParams(data);
  };
  const handlePageClick = (val) => {
    let data = {
      ...paramsObject,
      page_number: val.selected,
    };
    setGetListParams(data);
    setSearchParams(data);
  };
  const handleRevokeEmployee = () => {
    let data = {
      company_employee_id: userId,
    };
    revokeEmployee.mutate(data);
  };
  const [openUserDetailDrawer, setOpenUserDetailDrawer] = useState(false);
  const handleOpenResignEmployeeDetail = (company_employee_id) => {
    setUserId(company_employee_id);
    setOpenUserDetailDrawer(true);
  };
  const handleOpenRevokeUserModal = (e, company_employee_id) => {
    e.stopPropagation();
    handleFetchUserDocuments(company_employee_id);
  };
  return (
    <div className="py-10">
      <EmployeeTab />
      <div className="px-5 mt-5">
        <BreadCrumbs crumbs={breadcrumbs} />
      </div>
      <div className=" px-4 pt-4 w-[40%]">
        <input
          type="search"
          placeholder="Search By employee name..."
          name="search_query"
          value={paramsObject.search_query}
          className="input"
          onChange={handleSearch}
        />
      </div>
      {resignedUserList.isLoading ? (
        <div className=" flex items-center justify-center mt-10">
          {" "}
          <PrimaryLoader />
        </div>
      ) : (
        <>
          {resignedUserList.data?.data?.length <= 0 ? (
            <div className="text-center">
              <p className=" text-gray-700 text-3xl mt-4">No Employee Found</p>
            </div>
          ) : (
            <>
              <RoundedContainer className={"mx-4"}>
                <div class="max-w-full overflow-x-auto">
                  <Table className="table-auto w-full">
                    <TableHead>
                      <TableHeaderCell className="w-1/6">
                        Name
                      </TableHeaderCell>
                      <TableHeaderCell className="w-1/6">
                        Username
                      </TableHeaderCell>
                      <TableHeaderCell className="w-1/6">
                        Email
                      </TableHeaderCell>
                      <TableHeaderCell className="w-1/6">
                        Employee Code
                      </TableHeaderCell>
                      <TableHeaderCell className="w-1/6">
                        User Type
                      </TableHeaderCell>
                      <TableHeaderCell className="w-1/6 text-center">
                        Action
                      </TableHeaderCell>
                    </TableHead>
                    <TableBody>
                      {resignedUserList.data?.data?.map((data, index) => {
                        const {
                          employee_name,
                          username,
                          email,
                          company_employee_id,
                          type_of_employee,
                          employee_code,
                        } = data;
                        return (
                          <TableRow
                            key={index}
                            className="cursor-pointer"
                            onClick={() =>
                              handleOpenResignEmployeeDetail(company_employee_id)
                            }
                          >
                            <TableCell>
                              {employee_name}
                            </TableCell>
                            <TableCell>
                              {username}
                            </TableCell>
                            <TableCell>
                              {email}
                            </TableCell>
                            <TableCell>
                              {employee_code || "----"}
                            </TableCell>
                            <TableCell>
                              {type_of_employee}
                            </TableCell>
                            <TableCell>
                              <div className="flex items-center justify-center w-full">
                                <Button
                                  type="button"
                                  onClick={(e) =>
                                    handleOpenRevokeUserModal(e, company_employee_id)
                                  }
                                  className="space-x-2"
                                >
                                  <span>Revoke</span>
                                </Button>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              </RoundedContainer>
              <RoundedContainer className={"mx-4"}>
                <Pagination
                  currentPage={+paramsObject.page_number}
                  lengthofItems={resignedUserList.data?.total_count}
                  limit={paramsObject.limit}
                  onPageChange={handlePageClick}
                />
              </RoundedContainer>
            </>
          )}
        </>
      )}

      <Modal
        open={isOpenDocumentModal}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
      >
        <div className="w-[30%] bg-white absolute left-1/2 -translate-x-1/2 top-[20%] rounded">
          <div className="document-wrapper px-4 divide-y">
            <div className="document-head py-4">
              <div className="flex items-center justify-between">
                <h3 className=" text-gray-700 text-3xl font-semibold">
                  Revoke Employee
                </h3>
                <div
                  className=" w-6 h-6 cursor-pointer"
                  onClick={() => setIsOpenDocumentModal(false)}
                >
                  <XIcon className=" text-black w-full h-full" />
                </div>
              </div>
            </div>
            <div className="document-body py-4 max-h-96 overflow-auto">
              <p>Are You sure you want to revoke this employee?</p>
            </div>
            <div className="document-foot space-x-4 py-4">
              <Button
                disabled={revokeEmployee.isLoading}
                className=""
                onClick={handleRevokeEmployee}
              >
                <div className=" flex items-center justify-center space-x-3">
                  <span>Revoke</span>
                  {revokeEmployee.isLoading && <InlineLoader />}
                </div>
              </Button>
              <Button
                variant={"outline"}
                className=""
                onClick={() => setIsOpenDocumentModal(false)}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      {openUserDetailDrawer && (
        <SingleResignEmployeeDetail
          userId={userId}
          open={openUserDetailDrawer}
          handleCloseDialog={() => setOpenUserDetailDrawer(false)}
        />
      )}
    </div>
  );
};

export default ResignedEmployeeDetails;
